module.exports = __webpack_public_path__ + "static/media/llx.43e877b7.png";